import React from "react";
import "../../styles/css/custom-css/loader.css";

const Loader = () => {

  return <div className="loader"></div>;
};

export default Loader;
